import React from 'react';
import Skeleton from '@alfa-retail-react/components/skeleton';
import classNames from 'classnames';

import { WindowTypeName, windowTypeToClassName } from 'app/utils/useWindowType';
import 'app/component/skeleton/row/RowSkeleton.less';

export interface RowSkeletonProps {
    /**
     * Тип окна.
     */
    windowType: WindowTypeName;

    /**
     * CSS класс.
     */
    className?: string;

    isHideTitle?: boolean;
}

/**
 * Скелетон компонента строки.
 *
 * Отображение:
 * В десктоп версии: -----   ---
 * В мобильной версии:
 * `
 * ---
 * -----
 * `
 */
export const RowSkeleton = (props: RowSkeletonProps) => {
    const className = classNames(
        'rowSkeleton',
        props.className,
        windowTypeToClassName(props.windowType),
    );

    return (
        <div className={className}>
            {!props.isHideTitle ? (
                <Skeleton className={'title'} visible animate />
            ) : null}
            <Skeleton className={'value'} visible animate />
        </div>
    );
};
